import { render, staticRenderFns } from "./AssociatedProduct.vue?vue&type=template&id=668b57f9&scoped=true&"
import script from "./AssociatedProduct.vue?vue&type=script&lang=js&"
export * from "./AssociatedProduct.vue?vue&type=script&lang=js&"
import style0 from "./AssociatedProduct.vue?vue&type=style&index=0&id=668b57f9&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "668b57f9",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/forge/induline.salamander.live/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('668b57f9')) {
      api.createRecord('668b57f9', component.options)
    } else {
      api.reload('668b57f9', component.options)
    }
    module.hot.accept("./AssociatedProduct.vue?vue&type=template&id=668b57f9&scoped=true&", function () {
      api.rerender('668b57f9', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "resources/js/components/ui/AssociatedProduct.vue"
export default component.exports